import { Navigate, Outlet } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import FullLoader from 'components/Loader/FullLoader';

function PrivateRoute() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <FullLoader />;

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;
